export interface DeepStage {
  time: string;
  title: string;
  desc: string;
}

export interface DeepDive {
  id: string;
  tag: string;
  title: string;
  category: string;
  heat: number;
  updated: string;
  cover: string;
  intro: string;
  stages: DeepStage[];
}

export const deepDives: DeepDive[] = [
  {
    id: "dd-01",
    tag: "本周最热",
    title: "《长夜灯》从官宣到围读：一条脉络看懂整个节奏",
    category: "影视",
    heat: 98210,
    updated: "今天 10:26 更新",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20cinematic%20night%20scene%20with%20warm%20lantern%20glow%20and%20deep%20charcoal%20sky%2C%20teal%20and%20amber%20highlights%2C%20editorial%20poster%20style%2C%20no%20text&width=1000&height=640&seq=dd-nightlight-cover&orientation=landscape",
    intro:
      "这部剧从筹备到官宣节奏一直很稳，很多讨论其实都集中在同几个节点上。我们把公开信息按时间排好，方便你一次看懂现在走到哪一步、接下来还会有什么动作。",
    stages: [
      {
        time: "第 1 步",
        title: "项目立项与题材公开",
        desc: "片方最早只放出题材方向与大致拍摄周期，没有公布阵容，讨论量保持平稳。",
      },
      {
        time: "第 2 步",
        title: "主演阵容官宣",
        desc: "首张角色海报发布，双主角设定与番位顺序同时成为焦点，讨论量在两个小时内快速抬升。",
      },
      {
        time: "第 3 步",
        title: "剧本围读完成",
        desc: "片方在回应中提到围读已完成，预计下月进入正式拍摄，节奏进入执行阶段。",
      },
      {
        time: "第 4 步",
        title: "接下来看什么",
        desc: "按常见节奏，下一步大概率是定妆物料与开机信息。是否有番位相关说明，仍是评论区最关心的问题。",
      },
    ],
  },
  {
    id: "dd-02",
    tag: "持续发酵",
    title: "NEON 成员调整传闻：从爆料到官方回应的时间线",
    category: "娱乐",
    heat: 90440,
    updated: "昨天 23:12 更新",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20stage%20fog%20with%20coral%20and%20green%20light%20beams%2C%20dramatic%20concert%20atmosphere%2C%20editorial%20poster%20style%2C%20no%20text&width=1000&height=640&seq=dd-neon-cover&orientation=landscape",
    intro:
      "关于成员调整的说法，其实经历了'零星爆料—集中讨论—官方回应'三个阶段。官方回应之后问题没有完全落地，我们把公开信息整理成脉络，帮你判断哪些是可以确认的、哪些还只是讨论。",
    stages: [
      {
        time: "第 1 步",
        title: "零星爆料出现",
        desc: "社交平台出现零散说法，来源不明确，讨论量不高，属于典型的早期阶段。",
      },
      {
        time: "第 2 步",
        title: "讨论集中爆发",
        desc: "多方账号在同一时间段跟进，话题进入当天讨论榜前列，但说法之间仍存在不一致。",
      },
      {
        time: "第 3 步",
        title: "官方深夜回应",
        desc: "组合账号发布简短说明，表述为'正常阶段规划'，未给出具体安排，后续活动照常。",
      },
      {
        time: "第 4 步",
        title: "尚未落地的部分",
        desc: "具体安排与时间表仍待官方进一步说明，建议以正式公告为准，暂不转发单一来源的说法。",
      },
    ],
  },
];